module.exports = __webpack_public_path__ + "img/96.9118cbfd.png";